import axios from 'axios'
import { createCommonInterceptors } from '../common-interceptors'

export const monolithHttpClient = axios.create({
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  baseURL: '/dashboard/editor/api',
})

export const initializeMonolithHttpClientInterceptors = () => {
  createCommonInterceptors(monolithHttpClient)
}
